<template>
    <div @click="click" class="carousel-item-root clickable">
        <img
            :src="img"
            style="height: 120px; width: calc(100% - 40px); padding: 20px 0; object-fit: contain;"
            ref="img"
        />
        <div style="font-size: 14px; line-height: 40px; height: 40px;">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Carousel.Default',
    props: {
        title: String,
        click: Function,
        img: String,
    },

    data() {
        return {
            imgHeight: 100,
            height: 500,
        };
    },

    methods: {
        handleResizeEvent() {
            this.imgHeight = this.$refs.img.clientWidth;
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>

.carousel-item-root > img {
    width: 100%;
    object-fit: cover;
}
</style>
